import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { gql } from "@apollo/client";
import IdleTimer from "react-idle-timer";
import { deleteLogin, deleteTokens } from "../../auth";

import Header from "./Header/Header";
import Body from "./Body/Body";
import { apolloClient } from "../../index";
import { connect } from "react-redux";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../common/UserDataReducer";
import { notify } from "../../components/Notify/Notify";

class Layout extends Component {
  state = {
    currentUser: {
      profile: {
        role: {
          id: 0,
        },
      },
    },
    currentUserId: 0,
    navItems: [],
    timeout: 1000 * 900 * 1,
    userLoggedIn: false,
  };

  onIdle = (e) => {
    if (this.state.userLoggedIn) {
      if (
        new Date() - this.idleTimer.getLastActiveTime() >
        this.state.timeout
      ) {
        deleteTokens();
        deleteLogin("login");

        this.setState(
          {
            userLoggedIn: false,
            timeout: 1000 * 1000 * 1,
          },
          () => {
            this.state.userLoggedIn && this.props.history.push("/login");
            const title = "Success";
            const detail = "User Logged out successfully!";
            const type = "success";
            notify(title, detail, type);
          }
        );
      }
    }
  };

  getRoutes = (userRoleId) => {
    const basicRoutes = [
      {
        name: "Feed",
        link: "/feed",
      },
      {
        name: "Files",
        link: "/files",
      },
      {
        name: "Calendar",
        link: "/calendar",
      },
      {
        name: "Archives",
        link: "/archives",
      },
    ];

    if (userRoleId === 1 || userRoleId === 2) {
      // Admin or IT Admin
      return [
        ...basicRoutes,
        {
          name: "Requests",
          link: "/requests",
        },
        {
          name: "Admin Settings",
          link: "/admin-settings",
        },
      ];
    } else if (userRoleId === 3) {
      return [
        ...basicRoutes,
        {
          name: "Requests",
          link: "/requests",
        },
      ];
    } else {
      // Manager, User & Guest
      return basicRoutes;
    }
  };

  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query Me {
            me {
              id
              email
              firstName
              lastName
              username
              profile {
                id
                image
                role {
                  id
                  name
                }
              }
            }
          }
        `,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        if (
          result.data.me.id !== 1 &&
          result.data.me.id &&
          result.data.me.profile.role.id
        ) {
          if (
            this.props.userRoleId !== parseInt(result.data.me.profile.role.id)
          ) {
            this.props.updateUserRole(parseInt(result.data.me.profile.role.id));
          }
          this.props.updateCurrentUserInfo(result.data.me);
          this.setState({
            currentUser: result.data.me,
            currentUserId: parseInt(result.data.me.profile.role.id),
            navItems: this.getRoutes(parseInt(result.data.me.profile.role.id)),
            userLoggedIn: true,
            timeout: 1000 * 900 * 1,
          });
        } else {
          this.setState({ userLoggedIn: false, timeout: 1000 * 1000 * 1 });
        }
      })
      .catch((e) => {
        this.setState({ userLoggedIn: false, timeout: 1000 * 1000 * 1 });
      });
  }

  render() {
    return (
      <>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onIdle={this.onIdle}
          debounce={1000}
          timeout={this.state.timeout}
        />
        <Header
          currentUser={this.state.currentUser}
          currentUserId={this.state.currentUserId}
          navItems={this.state.navItems}
        ></Header>
        <Body
          currentUser={this.state.currentUser}
          currentUserId={this.state.currentUserId}
          navItems={this.state.navItems}
        ></Body>
        <ToastContainer />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
